import React, { useContext } from 'react';

import { Numeral } from 'numeral';
import { Moment } from 'moment';

import { useFeatureFlags } from '@hydra/common/components/FeatureFlags/featureFlagContext';
import { LanguagesTypes, LanguageLabelsInterface } from '@hydra/types';
import { localizeNumeral, localizeMoment } from './utils';

interface TranslateOptions {
  with: {}
}

interface I18nContextValue {
  translate: (tag: string, options?: TranslateOptions) => string;
  moment: (value?: string | number | Date) => Moment;
  numeral: (value: number) => Numeral;
  locale: LanguagesTypes;
  languageLabels: LanguageLabelsInterface;
  pathname: string
}

export const Context = React.createContext<I18nContextValue>({
  translate: (tag) => tag,
  moment: localizeMoment('en'),
  numeral: localizeNumeral('en'),
  locale: 'en',
  languageLabels: {
    en: 'English',
    fr: 'Français',
    pt: 'Português',
    nl: 'Nederlands',
    de: 'Deutsch',
    es: 'Español'
  },
  pathname: ''
});

interface I18nContextProps {
  i18n: I18nContextValue
  children: React.ReactNode
}

export function I18nContext (props: I18nContextProps) {
  const featureFlags = useFeatureFlags();
  const copyDebug = !!(featureFlags && featureFlags.copyDebug);
  return (
    <Context.Provider value={{
      translate: copyDebug ? a => a : props.i18n.translate,
      moment: props.i18n.moment,
      numeral: props.i18n.numeral,
      locale: props.i18n.locale,
      languageLabels: props.i18n.languageLabels,
      pathname: props.i18n.pathname
    }}
    >
      {props.children}
    </Context.Provider>
  );
}

export const useI18n = () => useContext(Context);
